[
	{
		"link": "https://thelinknewspaper.ca/article/k-pop-and-the-sanitization-of-black-culture",
		"title": "K-pop and the sanitization of Black culture",
		"section": "OPINIONS",
		"author": "Andra\u00e9 Lerone Lewis",
		"date": "2026-02-24T05:00:00.000Z",
		"excerpt": "K-pop embodies the pattern of Black music being policed at its source and profited from once repackaged for mainstream audiences.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/10_OPS_Kpop_EvelynHoLee_900_531_90.jpg"
		],
		"slug": "k-pop-and-the-sanitization-of-black-culture"
	},
	{
		"link": "https://thelinknewspaper.ca/article/higher-fees-smaller-futures",
		"title": "Editorial: Higher fees, smaller futures",
		"section": "OPINIONS",
		"author": "The Link",
		"date": "2026-02-10T05:00:00.000Z",
		"excerpt": "Quebec\u2019s decision to maintain steep tuition hikes makes it harder for out-of-province students to study at English-language universities. Students face growing financial pressure while universities warn that the policy is discouraging applications and weakening access to higher education.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/09.editorial.editorial.thelink.print.Andrae_Lerone_Lewis._U2A0410_900_450_90.jpg"
		],
		"slug": "higher-fees-smaller-futures"
	},
	{
		"link": "https://thelinknewspaper.ca/article/the-phd-trap",
		"title": "The PhD trap",
		"section": "NEWS",
		"author": "Varda Nisar",
		"date": "2026-01-27T05:00:00.000Z",
		"excerpt": "PhD students perform a wide range of services and labour for Concordia University, yet some feel that they are rarely acknowledged, and more often than not, their programs are framed as training and service.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/08.news.PhD.Varda.print.Andrae_Lerone_Lewis._U2A3752_900_1350_90.jpg"
		],
		"slug": "the-phd-trap"
	},
	{
		"link": "https://thelinknewspaper.ca/article/azzurri-10-stingers-0-italy-swarms-concordia",
		"title": "Azzurri 10, Stingers 0: Italy swarms Concordia",
		"section": "SPORTS",
		"author": "Samuel Kayll",
		"date": "2025-12-15T05:00:00.000Z",
		"excerpt": "The Concordia University women\u2019s hockey team suffered defeat in a matchup with the Italian national team as part of the Azzurri\u2019s pre-Olympic training tour.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/20251213-_U2A0920_900_450_90.jpg"
		],
		"slug": "azzurri-10-stingers-0-italy-swarms-concordia"
	},
	{
		"link": "https://thelinknewspaper.ca/article/walkout-staged-at-concordia-following-ban-of-student-union-staff-member-from-campus",
		"title": "Walkout staged at Concordia following ban of student union staff member from campus",
		"section": "NEWS",
		"author": "Ryan Pyke",
		"date": "2025-12-04T05:00:00.000Z",
		"excerpt": "A Dec. 1 walkout planned to take place at Concordia University\u2019s Henry F. Hall building ended with a march down De Maisonneuve Blvd. W.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/06.news.Dec1Walkout.Ryan.online.shadowlerone._U2A6266_900_600_90.jpg",
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/06.news.Dec1Walkout.Ryan.online.shadowlerone._U2A6120_900_1350_90.jpg",
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/06.news.Dec1Walkout.Ryan.online.Andrae_Lerone_Lewis._U2A6428_900_600_90.jpg",
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/06.news.Dec1Walkout.Ryan.online.Andrae_Lerone_Lewis._U2A6236_900_600_90.jpg"
		],
		"slug": "walkout-staged-at-concordia-following-ban-of-student-union-staff-member-from-campus"
	},
	{
		"link": "https://thelinknewspaper.ca/article/necessary-but-never-allowed-to-stay",
		"title": "Necessary but never allowed to stay",
		"section": "OPINIONS",
		"author": "Reza Taher-Kermani",
		"date": "2025-11-18T05:00:00.000Z",
		"excerpt": "I am one of the many faculty employed on precarious one-year contracts at Concordia University, and the recent decision to end our positions just as we were finally approaching the possibility of more secure roles not only threatens our livelihoods but also undermines the relationships, care and continuity that make\u2026",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/06.opinions.LTA.__.print.Andrae_Lerone_Lewis._U2A3797_900_600_90.jpg"
		],
		"slug": "necessary-but-never-allowed-to-stay"
	},
	{
		"link": "https://thelinknewspaper.ca/article/new-dinner-initiative-feeds-students-concordia-downtown-campus",
		"title": "New dinner initiative feeds students on Concordia\u2019s downtown campus",
		"section": "NEWS",
		"author": "Kara Brulotte",
		"date": "2025-11-04T05:00:00.000Z",
		"excerpt": "A new dinner program run by the Spinach Collective has popped up on Concordia University\u2019s downtown campus to combat student food insecurity.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/05.news.Spinach_Collective.Kara.print.Andrae_Lerone_Lewis._U2A7344_900_600_90.jpg",
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/05.news.Spinach_Collective.Kara.print.Andrae_Lerone_Lewis._U2A7325_900_600_90.jpg",
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/05.news.Spinach_Collective.Kara.print.Andrae_Lerone_Lewis._U2A7352_900_600_90.jpg"
		],
		"slug": "new-dinner-initiative-feeds-students-concordia-downtown-campus"
	},
	{
		"link": "https://thelinknewspaper.ca/article/voting-should-be-more-accessible-and-community-focused-montreal-students-say",
		"title": "Voting should be more accessible and community-focused, Montreal students say",
		"section": "NEWS",
		"author": "Racha Rais",
		"date": "2025-10-31T04:00:00.000Z",
		"excerpt": "Concordia University students and a voting expert weigh in on why some Montreal youth are having trouble choosing a candidate to vote for in the coming municipal elections on Nov. 2.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/04.editorial.normal_Editorial.The_Link.print.Andrae_Lerone_Lewis.20250819-_U2A3392_1_900_600_90.jpg"
		],
		"slug": "voting-should-be-more-accessible-and-community-focused-montreal-students-say"
	},
	{
		"link": "https://thelinknewspaper.ca/article/stingers-5-martlets-0-concordia-opens-home-conference-play-with-a-shutout",
		"title": "Stingers 5, Martlets 0: Concordia opens home conference play with a shutout",
		"section": "SPORTS",
		"author": "Samuel Kayll",
		"date": "2025-10-27T04:00:00.000Z",
		"excerpt": "With high expectations for the year, the Concordia University women\u2019s hockey team reminded everyone of its dominance with a straightforward home win.",
		"images": [
			"/assets/published/_U2A0597.jpg"
		],
		"slug": "stingers-5-martlets-0-concordia-opens-home-conference-play-with-a-shutout"
	},
	{
		"link": "https://thelinknewspaper.ca/article/the-pill-problem",
		"title": "The Pill problem",
		"section": "NEWS",
		"author": "Sean Richard",
		"date": "2025-10-21T04:00:00.000Z",
		"excerpt": "Women must often either take a form of birth control when they enter a relationship or when experiencing painful menstrual symptoms. While there have not been enough advances to ease the pressure on women, services like the Centre de sant\u00e9 des femmes de Montr\u00e9al offer safe spaces for women to\u2026",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/04.news.Birth_Control.Sean.print.Andrae_Lerone_Lewis._U2A7033_900_568_90.jpg"
		],
		"slug": "the-pill-problem"
	},
	{
		"link": "https://thelinknewspaper.ca/article/editorial-the-streets-have-made-our-voices-heard-now-the-polls-will",
		"title": "Editorial: The streets have made our voices heard. Now, the polls will.",
		"section": "OPINIONS",
		"author": "The Link",
		"date": "2025-10-21T04:00:00.000Z",
		"excerpt": "Montrealers have marched, protested and demanded change. Now, the city\u2019s future depends on the choices we make at the polls.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/04.editorial.normal_Editorial.The_Link.print.Andrae_Lerone_Lewis.20250819-_U2A3392_900_600_90.jpg"
		],
		"slug": "editorial-the-streets-have-made-our-voices-heard-now-the-polls-will"
	},
	{
		"link": "https://thelinknewspaper.ca/article/heavy-with-desire",
		"title": "Heavy with desire",
		"section": "FRINGE ARTS",
		"author": "Safa Hachi",
		"date": "2025-10-21T04:00:00.000Z",
		"excerpt": "A poem about the weight of being seen\u2014when the world demands smallness, desire becomes its own power.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/04.editorial.Cover.The_Link.print.Andrae_Lerone_Lewis._U2A6027_900_1350_90.jpg"
		],
		"slug": "heavy-with-desire"
	},
	{
		"link": "https://thelinknewspaper.ca/article/pro-palestine-strikes-concordia-two-arrests-campus-closure",
		"title": "Pro-Palestine strikes at Concordia see two arrests and campus closure",
		"section": "NEWS",
		"author": "Maria Cholakova",
		"date": "2025-10-09T04:00:00.000Z",
		"excerpt": "Heavy police presence and arrests once again marked student strikes at Concordia University. Over 80,000 students were officially on strike on Oct. 6 and Oct. 7 across Montreal.",
		"images": [
			"/assets/published/_U2A5514.jpg",
			"/assets/published/_U2A5523.jpg",
			"/assets/published/_U2A5007.jpg",
			"/assets/published/_U2A5543.jpg",
			"/assets/published/_U2A3611.jpg",
			"/assets/published/_U2A3629.jpg",
			"/assets/published/_U2A3515.jpg"
		],
		"slug": "pro-palestine-strikes-concordia-two-arrests-campus-closure"
	},
	{
		"link": "https://thelinknewspaper.ca/article/lavender-town-and-mafuba-light-up-petit-campus",
		"title": "Lavender Town and Mafuba light up Petit Campus",
		"section": "FRINGE ARTS",
		"author": "Safa Hachi",
		"date": "2025-10-09T04:00:00.000Z",
		"excerpt": "Lavender Town and Mafuba transformed Petit Campus on Oct. 6 into a pulse of brass, bass and movement. The two bands\u2019 takes on jazz turned a mundane Monday into a night that felt alive from the first to last note.",
		"images": [
			"/assets/published/_U2A2271.jpg",
			"/assets/published/_U2A2928.jpg",
			"/assets/published/_U2A2346.jpg"
		],
		"slug": "lavender-town-and-mafuba-light-up-petit-campus"
	},
	{
		"link": "https://thelinknewspaper.ca/article/concordia-researchers-create-new-model-for-tracking-pathogens",
		"title": "Concordia researchers create new model for tracking pathogens",
		"section": "NEWS",
		"author": "Kara Brulotte",
		"date": "2025-09-30T04:00:00.000Z",
		"excerpt": "Concordia University researchers develop a faster model to track pathogens, which has big implications for managing disease spread.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/03.news.diseasetransmission.kara.print.Andrae_Lerone_Lewis._U2A9449_900_600_90.jpg"
		],
		"slug": "concordia-researchers-create-new-model-for-tracking-pathogens"
	},
	{
		"link": "https://thelinknewspaper.ca/article/stingers-hockey-elects-new-leadership",
		"title": "Stingers hockey elects new leadership",
		"section": "SPORTS",
		"author": "Max Sinclair-Carter",
		"date": "2025-09-30T04:00:00.000Z",
		"excerpt": "Jessymaude Drapeau and Simon Lavigne will represent the Concordia University hockey teams as captains during the 2025-26 season. Through their skill and experience, they\u2019ve shown that they\u2019re the right players for the job.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/03.sports.Stingers_hockey_captains.Max.print.Andrae_Lerone_Lewis.EU2A0549_900_600_90.jpg"
		],
		"slug": "stingers-hockey-elects-new-leadership"
	},
	{
		"link": "https://thelinknewspaper.ca/article/mfas-against-genocide-boycott-concordia-fellowship",
		"title": "MFAs Against Genocide announces boycott of Concordia Fellowship",
		"section": "NEWS",
		"author": "Chantal Bellefeuille",
		"date": "2025-09-30T04:00:00.000Z",
		"excerpt": "The anonymous collective MFAs Against Genocide recently launched a boycott campaign against Concordia University\u2019s Claudine and Stephen Bronfman Fellowship in Contemporary Art.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/03.news.MFA_Boycott.Chantale.print.Andrae_Lerone_Lewis._U2A9439_900_600_90.jpg"
		],
		"slug": "mfas-against-genocide-boycott-concordia-fellowship"
	},
	{
		"link": "https://thelinknewspaper.ca/article/fasa-first-student-association-to-vote-to-strike-for-palestine",
		"title": "FASA first student association to vote to strike for Palestine",
		"section": "NEWS",
		"author": "Maria Cholakova",
		"date": "2025-09-23T04:00:00.000Z",
		"excerpt": "Nearly a year after Concordia University students last went on strike for Palestine, student groups are once again mobilizing strike votes to pressure the university to divest from weapons manufacturers linked to Israel\u2019s genocide in Gaza.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/20241121-_U2A9716_900_600_90.jpg"
		],
		"slug": "fasa-first-student-association-to-vote-to-strike-for-palestine"
	},
	{
		"link": "https://thelinknewspaper.ca/article/artists-and-activists-withdraw-works-call-for-boycott-of-concordias-gallery",
		"title": "Artists and activists withdraw works, call for boycott of Concordia\u2019s gallery",
		"section": "NEWS",
		"author": "Maria Cholakova",
		"date": "2025-09-16T04:00:00.000Z",
		"excerpt": "Several artists have withdrawn their work from Concordia University\u2019s Leonard &amp; Bina Ellen Art Gallery, joining activists in a boycott over what they describe as the university\u2019s censorship of pro-Palestine voices.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/02.news.Gallery.Maria_Cholakova.print.Andrae_Lerone_Lewis._U2A8031_900_600_90.jpg"
		],
		"slug": "artists-and-activists-withdraw-works-call-for-boycott-of-concordias-gallery"
	},
	{
		"link": "https://thelinknewspaper.ca/article/student-housing-a-human-right-worth-fighting-for",
		"title": "Student housing, a human right worth fighting for",
		"section": "NEWS",
		"author": "Sean Richard",
		"date": "2025-09-16T04:00:00.000Z",
		"excerpt": "Concordia University students are struggling to find affordable housing. While organizations like HOJO and Vivre en Ville educate tenants on their rights, they still feel the need to mobilize to have their demands met.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/02.news.Rent_Control.Sean_Richard.print.Andrae_Lerone_Lewis._U2A7382_900_600_90.jpg"
		],
		"slug": "student-housing-a-human-right-worth-fighting-for"
	},
	{
		"link": "https://thelinknewspaper.ca/article/editorial-planting-down-roots",
		"title": "Editorial: Planting down roots",
		"section": "OPINIONS",
		"author": "The Link",
		"date": "2025-09-02T04:00:00.000Z",
		"excerpt": "The Link is looking to find steady ground after years of transitions with a new team, publication schedule and pay structure.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/Fuji400_-_Farah_and_Hike-000084680028_900_596_90.jpg"
		],
		"slug": "editorial-planting-down-roots"
	},
	{
		"link": "https://thelinknewspaper.ca/article/what-happened-last-year-concordia-university",
		"title": "What happened last year at Concordia University",
		"section": "NEWS",
		"author": "India Das-Brown",
		"date": "2025-09-02T04:00:00.000Z",
		"excerpt": "Walkouts, sit-ins and advisory council resignations peppered Concordia University\u2019s timeline last year. This retrospective looks at what happened and how the university responded.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/20241121-EU2A9494_900_600_90.jpg"
		],
		"slug": "what-happened-last-year-concordia-university"
	},
	{
		"link": "https://thelinknewspaper.ca/article/a-look-behind-the-curtain-of-concordia-recruiting",
		"title": "A look behind the curtain of Concordia recruiting",
		"section": "SPORTS",
		"author": "Samuel Kayll",
		"date": "2025-09-02T04:00:00.000Z",
		"excerpt": "Behind every Concordia University athlete lies a complex and detailed recruiting process, each carefully constructed by their program",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/01.sports.Stingers_Recruitment.Samuel_Kayll.print.Andrae_Lerone_Lewis._U2A3631_900_600_90.jpg"
		],
		"slug": "a-look-behind-the-curtain-of-concordia-recruiting"
	},
	{
		"link": "https://thelinknewspaper.ca/article/montrealers-rally-against-education-cuts-ahead-of-back-to-school-season",
		"title": "Montrealers rally against education cuts ahead of back-to-school season",
		"section": "NEWS",
		"author": "Hannah Beach",
		"date": "2025-08-28T04:00:00.000Z",
		"excerpt": "Protesters spoke out against education cuts made by the Legault government back in May. They say that the partial reversal is not enough and does not give schools adequate time to restore services.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/00.news.education_budget_cuts.Hannah_Beach.online.Andrae_Lerone_Lewis._U2A3500_900_600_90.jpg",
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/00.news.education_budget_cuts.Hannah_Beach.online.Andrae_Lerone_Lewis._U2A3527_900_600_90.jpg",
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/00.news.education_budget_cuts.Hannah_Beach.online.Andrae_Lerone_Lewis._U2A3538_900_600_90.jpg",
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/00.news.education_budget_cuts.Hannah_Beach.online.Andrae_Lerone_Lewis._U2A3520_900_600_90.jpg",
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/00.news.education_budget_cuts.Hannah_Beach.online.Andrae_Lerone_Lewis._U2A3605_900_600_90.jpg",
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/00.news.education_budget_cuts.Hannah_Beach.online.Andrae_Lerone_Lewis._U2A3579_900_600_90.jpg"
		],
		"slug": "montrealers-rally-against-education-cuts-ahead-of-back-to-school-season"
	},
	{
		"link": "https://thelinknewspaper.ca/article/Indigenous-voices-Montreal-International-First-Peoples-Festival",
		"title": "Indigenous voices to gather for Montreal\u2019s International First Peoples\u2019 Festival",
		"section": "FRINGE ARTS",
		"author": "India Das-Brown",
		"date": "2025-08-04T04:00:00.000Z",
		"excerpt": "Indigenous artists from across the globe will gather in Montreal this August for a 10-day celebration of arts, resistance and unity at the 35th International First Peoples\u2019 Festival.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/00.fringe.India.festival.online.Andrae.1198_900_600_90.jpg"
		],
		"slug": "Indigenous-voices-Montreal-International-First-Peoples-Festival"
	},
	{
		"link": "https://thelinknewspaper.ca/article/thousands-attend-palestine-in-the-park-fundraiser-for-gaza-in-montreal",
		"title": "Thousands attend \u2018Palestine in the Park\u2019 fundraiser for Gaza in Montreal",
		"section": "NEWS",
		"author": "Hannah Scott-Talib",
		"date": "2025-07-28T04:00:00.000Z",
		"excerpt": "Thousands of people made their way to Angrignon Park on July 26, for what Montreal\u2019s Palestinian Youth Movement is calling their largest fundraiser for Palestine to date.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/00.news.PalestineFestival.Hannah_Scott-Talib.online.Andrae_Lerone_Lewis._U2A2309_900_600_90.jpg",
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/00.news.PalestineFestival.Hannah_Scott-Talib.online.Andrae_Lerone_Lewis._U2A2334_900_600_90.jpg"
		],
		"slug": "thousands-attend-palestine-in-the-park-fundraiser-for-gaza-in-montreal"
	},
	{
		"link": "https://thelinknewspaper.ca/article/this-is-not-humanitarian-relief-montrealers-gather-to-protest-starvation-in-gaza",
		"title": "\u2018This is not humanitarian relief\u2019: Montrealers gather to protest starvation in Gaza",
		"section": "NEWS",
		"author": "Genevi\u00e8ve Sylvestre",
		"date": "2025-07-24T04:00:00.000Z",
		"excerpt": "Over 200 Montrealers gathered in front of the United States Consulate General to demand an end to Israel\u2019s militarized aid distribution system and a lift of the siege on Gaza.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/00.news.Gen.PYM22July.online.Andrae.1659_900_600_90.jpg",
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/00.news.Gen.PYM22July.online.Andrae.1604_900_600_90.jpg"
		],
		"slug": "this-is-not-humanitarian-relief-montrealers-gather-to-protest-starvation-in-gaza"
	},
	{
		"link": "https://thelinknewspaper.ca/article/a-night-into-the-unknown-with-concordias-fashion-business-association",
		"title": "A night into the unknown with Concordia\u2019s Fashion Business Association",
		"section": "FRINGE ARTS",
		"author": "Jayde Lazier",
		"date": "2025-04-13T04:00:00.000Z",
		"excerpt": "The Concordia University Fashion Business Association hosted their third annual fashion showcase that featured local designers and their newest collections at the Th\u00e9\u00e2tre Cartier on April 11.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/12.fringe.CFBA.Jayde.online.Andrae_Lerone_Lewis._U2A0824_900_600_90.jpg"
		],
		"slug": "a-night-into-the-unknown-with-concordias-fashion-business-association"
	},
	{
		"link": "https://thelinknewspaper.ca/article/concordia-university-owns-more-than-1.4-billion-in-real-estate-property",
		"title": "Concordia University owns more than $1.4 billion in real estate property",
		"section": "NEWS",
		"author": "Autumn Darey",
		"date": "2025-04-01T04:00:00.000Z",
		"excerpt": "Concordia\u2019s real estate holdings now include office buildings, an apartment building and various mixed-use spaces valued at over $1.4 billion.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/12.news.Concordia_buildings.Autumn_Darey.print.Andrae_Lerone_Lewis._U2A9633_900_600_90.jpg"
		],
		"slug": "concordia-university-owns-more-than-1"
	},
	{
		"link": "https://thelinknewspaper.ca/article/conus-economics-education-the-potential-key-to-equality",
		"title": "ConU\u2019s economics education: The potential key to equality",
		"section": "NEWS",
		"author": "Iness Rifay",
		"date": "2025-04-01T04:00:00.000Z",
		"excerpt": "How alumni and professors alike are working to improve the state of DEI in economics",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/12.news.DEI_Economics.Iness.print.Andrae_Lerone_Lewis._U2A9725_900_1350_90.jpg"
		],
		"slug": "conus-economics-education-the-potential-key-to-equality"
	},
	{
		"link": "https://thelinknewspaper.ca/article/the-jewish-left-and-the-right-to-dissent",
		"title": "The Jewish Left and the right to dissent",
		"section": "OPINIONS",
		"author": "Jordan Molot",
		"date": "2025-03-21T04:00:00.000Z",
		"excerpt": "To quote an old professor of mine: it takes a village to think. But it may also be worthwhile travelling outside of one\u2019s familiar terrain in order to discover new, potentially destabilizing, horizons.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/09.news.Jewish_Left.Hannah_Scott.print.Andrae_Lerone_Lewis.EU2A9415_(1)_900_600_90.jpg"
		],
		"slug": "the-jewish-left-and-the-right-to-dissent"
	},
	{
		"link": "https://thelinknewspaper.ca/article/stingers-2-gaels-1-concordias-late-comeback-stuns-queens",
		"title": "Stingers 2, Gaels 1: Concordia\u2019s late comeback stuns Queen\u2019s",
		"section": "SPORTS",
		"author": "Samuel Kayll",
		"date": "2025-03-07T05:00:00.000Z",
		"excerpt": "A wild third frame ended with the Concordia University Stingers men\u2019s hockey team taking Game 1 of its Ontario University Athletics (OUA) semifinal matchup with the Queen\u2019s University Gaels.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/10.sports.MHKYvQUEEN.samuel_Kayll.online.Andrae_Lerone_Lewis._U2A6968_900_600_90.jpg"
		],
		"slug": "stingers-2-gaels-1-concordias-late-comeback-stuns-queens"
	},
	{
		"link": "https://thelinknewspaper.ca/article/stingers-6-martlets-1-a-game-to-remember",
		"title": "Stingers 6, Martlets 1: A game to remember",
		"section": "SPORTS",
		"author": "Brendan Schwartz",
		"date": "2025-03-02T05:00:00.000Z",
		"excerpt": "The Concordia University Stingers\u2019 6-1 win against the McGill University Martlets leads them to the RSEQ finals against the Bishop\u2019s University Gaiters.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/09.sports.WHKYvMCG.Brendan_Schwartz.online.Andrae_Lerone_Lewis._U2A5651_900_600_90.jpg"
		],
		"slug": "stingers-6-martlets-1-a-game-to-remember"
	},
	{
		"link": "https://thelinknewspaper.ca/article/montrealers-protest-against-amazons-anti-union-actions",
		"title": "Montrealers protest against Amazon\u2019s anti-union actions",
		"section": "NEWS",
		"author": "Ryan Pyke",
		"date": "2025-02-17T05:00:00.000Z",
		"excerpt": "Activist groups, union groups and citizens in Montreal met outside the Mont-Royal metro and marched the streets to protest against Amazon.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/09.news.CSN_Strike.Ryan_Pyke.online.Andrae_Lerone_Lewis._U2A2736_900_600_90.jpg"
		],
		"slug": "montrealers-protest-against-amazons-anti-union-actions"
	},
	{
		"link": "https://thelinknewspaper.ca/article/the-student-body-wont-be-silenced-not-now-not-ever",
		"title": "Editorial: The student body won\u2019t be silenced. Not now, not ever.",
		"section": "OPINIONS",
		"author": "The Link",
		"date": "2025-02-11T05:00:00.000Z",
		"excerpt": "Students voted overwhelmingly in favour of the BDS motion in an astounding display of democratic passion, with a final tally of 885 votes for and 58 votes against",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/09.editorial.EDITORIAL.THELINK.print.Andrae_Lerone_Lewis._U2A2568_900_1350_90.jpg"
		],
		"slug": "the-student-body-wont-be-silenced-not-now-not-ever"
	},
	{
		"link": "https://thelinknewspaper.ca/article/concordia-university-presidents-statement-draws-criticism",
		"title": "Concordia University president\u2019s statement draws criticism",
		"section": "NEWS",
		"author": "Genevi\u00e8ve Sylvestre",
		"date": "2025-02-11T05:00:00.000Z",
		"excerpt": "Students at Concordia University raise concern about the university\u2019s President\u2019s statement following a special general meeting where undergraduate students voted in favour of two BDS motions.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/08.news.SGM.Zita.online.Andrae_Lerone_Lewis._U2A1642_900_600_90.jpg"
		],
		"slug": "concordia-university-presidents-statement-draws-criticism"
	},
	{
		"link": "https://thelinknewspaper.ca/article/the-rise-of-montreals-jewish-left",
		"title": "The rise of Montreal\u2019s Jewish Left",
		"section": "NEWS",
		"author": "Hannah Scott-Talib",
		"date": "2025-02-11T05:00:00.000Z",
		"excerpt": "Jewish pro-Palestine activists speak out about their cultural upbringings and the history of anti-Zionist Judaism.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/09.news.Jewish_Left.Hannah_Scott.print.Andrae_Lerone_Lewis.EU2A9681_900_600_90.jpg"
		],
		"slug": "the-rise-of-montreals-jewish-left"
	},
	{
		"link": "https://thelinknewspaper.ca/article/igloofest-2025-montreals-winter-nightlife-crown-jewel",
		"title": "Igloofest 2025: Montreal\u2019s winter nightlife crown jewel",
		"section": "FRINGE ARTS",
		"author": "Safa Hachi",
		"date": "2025-02-01T05:00:00.000Z",
		"excerpt": "Montreal\u2019s Igloofest is lighting up the Old Port with electrifying performances, featuring global stars like Skepta and local DJs who bring unique energy to winter nightlife.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/08.fringe.Igloofest.Safa.online.Andrae_Lerone_Lewis._U2A9593_900_600_90.jpg"
		],
		"slug": "igloofest-2025-montreals-winter-nightlife-crown-jewel"
	},
	{
		"link": "https://thelinknewspaper.ca/article/editorial-if-youre-reading-this-its-not-too-late-go-to-the-csus-sgm",
		"title": "Editorial: If you\u2019re reading this, it\u2019s not too late, go to the CSU\u2019s SGM",
		"section": "OPINIONS",
		"author": "The Link",
		"date": "2025-01-28T05:00:00.000Z",
		"excerpt": "We, as students, have the moral obligation to support our fellow activists who have been fighting to make their voices heard.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/08.editorial.Editorial.The_Link.print.Editorial._U2A1533_900_600_90.jpg"
		],
		"slug": "editorial-if-youre-reading-this-its-not-too-late-go-to-the-csus-sgm"
	},
	{
		"link": "https://thelinknewspaper.ca/article/stingers-2-martlets-1-concordia-stifles-mcgill",
		"title": "Stingers 2, Martlets 1: Concordia stifles McGill",
		"section": "SPORTS",
		"author": "Samuel Kayll",
		"date": "2025-01-21T05:00:00.000Z",
		"excerpt": "The Concordia University Stingers opened the new year with a back-and-forth victory over the cross-town rival Martlets.",
		"images": [
			"/assets/published/_U2A9596.jpg"
		],
		"slug": "stingers-2-martlets-1-concordia-stifles-mcgill"
	},
	{
		"link": "https://thelinknewspaper.ca/article/gaza-ceasefire-announcement-drives-hundreds-of-montrealers-to-the-streets",
		"title": "Gaza ceasefire announcement drives hundreds of Montrealers to the streets",
		"section": "NEWS",
		"author": "Safa Hachi",
		"date": "2025-01-17T05:00:00.000Z",
		"excerpt": "Protesters took to the streets of downtown Montreal to celebrate the Gaza ceasefire announcement, honour the lives lost, and call for continued resistance and a free Palestine.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/1000008920_900_599_90.jpg"
		],
		"slug": "gaza-ceasefire-announcement-drives-hundreds-of-montrealers-to-the-streets"
	},
	{
		"link": "https://thelinknewspaper.ca/article/the-detriments-of-bill-83",
		"title": "The detriments of Bill 83",
		"section": "NEWS",
		"author": "Kara Brulotte",
		"date": "2025-01-14T05:00:00.000Z",
		"excerpt": "Quebec\u2019s Bill 83 puts the future plans of aspiring medical students at risk.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/07.feature.news.healthcare.kara.print.Andrae_Lerone_Lewis._U2A8491_900_1350_90.jpg"
		],
		"slug": "the-detriments-of-bill-83"
	},
	{
		"link": "https://thelinknewspaper.ca/article/nikolas-hurtubise-twice-the-gain",
		"title": "Nikolas Hurtubise: Twice the gain",
		"section": "SPORTS",
		"author": "Samuel Kayll",
		"date": "2025-01-14T05:00:00.000Z",
		"excerpt": "As the Concordia University men\u2019s hockey team blazes through the regular season, Nikolas Hurtubise and his heroics in goal may fly under the radar. But don\u2019t worry\u2014he\u2019s used to proving people wrong.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/07.sports.Nikolas_Hurtubise_Profile.Samuel_Kayll.print.Andrae_Lerone_Lewis.EU2A8503_900_1190_90.jpg",
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/07.sports.Nikolas_Hurtubise_Profile.Samuel_Kayll.print.Andrae_Lerone_Lewis._U2A4616_(1)_900_600_90.jpg"
		],
		"slug": "nikolas-hurtubise-twice-the-gain"
	},
	{
		"link": "https://thelinknewspaper.ca/article/how-student-unions-have-shaped-quebec-one-battle-at-a-time",
		"title": "How student unions have shaped Quebec, one battle at a time",
		"section": "OPINIONS",
		"author": "Adam Semergian",
		"date": "2025-01-14T05:00:00.000Z",
		"excerpt": "Quebec student unions have been at the forefront of political change for decades, from the 1960s education reform movement to the Palestine BDS movement.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/07.opinions.Student_Unions.Adam_Semergian.print.Andrae_Lerone_Lewis._Z9A8074_900_600_90.jpg"
		],
		"slug": "how-student-unions-have-shaped-quebec-one-battle-at-a-time"
	},
	{
		"link": "https://thelinknewspaper.ca/article/quebec-is-deficient-in-diagnoses",
		"title": "Quebec is deficient in diagnoses",
		"section": "NEWS",
		"author": "Hayley Carolan",
		"date": "2025-01-14T05:00:00.000Z",
		"excerpt": "Iron deficiency remains an overlooked health issue for women in Quebec.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/07.feature.news.Iron_Deficiency.Hayley_Carolan.print.Andrae_Lerone_Lewis._U2A8443_900_506_90.jpg"
		],
		"slug": "quebec-is-deficient-in-diagnoses"
	},
	{
		"link": "https://thelinknewspaper.ca/article/stingers-7-warriors-2-concordia-clamps-down-waterloo",
		"title": "Stingers 7, Warriors 2: Concordia clamps down Waterloo",
		"section": "SPORTS",
		"author": "Samuel Kayll",
		"date": "2025-01-13T05:00:00.000Z",
		"excerpt": "The shorthanded Stingers still shut down the Waterloo Warriors to continue their winning ways.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/07.sports.MHKYvWAT.Samuel_Kayll.online.Andrae_Lerone_Lewis._U2A6250_900_1097_90.jpg"
		],
		"slug": "stingers-7-warriors-2-concordia-clamps-down-waterloo"
	},
	{
		"link": "https://thelinknewspaper.ca/article/lancers-4-stingers-2-lancers-crush-stingers-in-first-at-home-loss",
		"title": "Lancers 4, Stingers 2: Lancers crush Stingers in first at-home loss",
		"section": "SPORTS",
		"author": "Brendan Schwartz",
		"date": "2025-01-12T05:00:00.000Z",
		"excerpt": "\u201cGood teams find a way to win after a loss,\u201d Stingers defenceman Nathan Lavoie said after their first regular season loss at the Ed Meagher Arena.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/07.sports.MHKYvWIN.Brendan.online.Andrae_Lerone_Lewis._U2A5860_900_900_90.jpg"
		],
		"slug": "lancers-4-stingers-2-lancers-crush-stingers-in-first-at-home-loss"
	},
	{
		"link": "https://thelinknewspaper.ca/article/montreal-creatives-shine-on-the-runway",
		"title": "Montreal creatives shine on the runway",
		"section": "FRINGE ARTS",
		"author": "Yasmine Chouman",
		"date": "2024-11-25T05:00:00.000Z",
		"excerpt": "Montreal fashion lovers popped off with their best looks at Artist Impact Movement\u2019s IMPACT fashion show.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/06.Fringe.AIM_Charity_Fashion_Show.Yasmine.online.Andrae_Lerone_Lewis._U2A5666_900_1350_90.jpg",
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/06.Fringe.AIM_Charity_Fashion_Show.Yasmine.online.Andrae_Lerone_Lewis._U2A3372_900_600_90.jpg",
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/06.Fringe.AIM_Charity_Fashion_Show.Yasmine.online.Andrae_Lerone_Lewis._U2A5421_900_1350_90.jpg"
		],
		"slug": "montreal-creatives-shine-on-the-runway"
	},
	{
		"link": "https://thelinknewspaper.ca/article/students-picket-and-take-over-hall-building-on-first-day-of-strikes",
		"title": "Students picket and take over Hall building on first day of strikes",
		"section": "NEWS",
		"author": "Maria Cholakova",
		"date": "2024-11-21T05:00:00.000Z",
		"excerpt": "As part of the International University Day of Action for Palestine, Concordia University students picketed classrooms and took over the Hall building.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/06.News.Nov_Student_Strike..online.shadowlerone.9543_900_600_90.jpg",
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/06.News.Nov_Student_Strike..online.shadowlerone.9138_900_600_90.jpg",
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/06.News.Nov_Student_Strike..online.shadowlerone.9539_900_1350_90.jpg"
		],
		"slug": "students-picket-and-take-over-hall-building-on-first-day-of-strikes"
	},
	{
		"link": "https://thelinknewspaper.ca/article/understanding-the-path-to-drug-decriminalization",
		"title": "Understanding the path to drug decriminalization",
		"section": "NEWS",
		"author": "Hannah Kazemi",
		"date": "2024-10-22T04:00:00.000Z",
		"excerpt": "The movement to decriminalize drugs has yielded positive outcomes, though not without undergoing several amendments along the way.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/04.News.decriminalize_drugs..print.Andrae_Lerone_Lewis.0705_900_900_90.jpg"
		],
		"slug": "understanding-the-path-to-drug-decriminalization"
	},
	{
		"link": "https://thelinknewspaper.ca/article/the-nuances-of-cannabis-legalization",
		"title": "The nuances of cannabis legalization",
		"section": "NEWS",
		"author": "Marco Deveaux",
		"date": "2024-10-22T04:00:00.000Z",
		"excerpt": "The recent legalization of cannabis in Canada is deeply rooted in a history of criminalization across North America.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/04.News.weed.Marco.print.Andrae_Lerone_Lewis.0743_900_600_90.jpg"
		],
		"slug": "the-nuances-of-cannabis-legalization"
	},
	{
		"link": "https://thelinknewspaper.ca/article/evolving-blood-donation-policies-for-gay-men",
		"title": "Evolving blood donation policies for gay men",
		"section": "NEWS",
		"author": "Megan Mills Devoe",
		"date": "2024-10-22T04:00:00.000Z",
		"excerpt": "Blood donation bans for gay men no longer last a lifetime, yet how much more inclusive are they?",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/04.News...print.Andrae_Lerone_Lewis.0729_900_1350_90.jpg"
		],
		"slug": "evolving-blood-donation-policies-for-gay-men"
	},
	{
		"link": "https://thelinknewspaper.ca/article/breaking-the-colonial-wall-over-1000-students-walk-out-for-divestment-on-the-anniversary-of-oct-7",
		"title": "Over 1000 students walk out for divestment on the anniversary of Oct. 7",
		"section": "NEWS",
		"author": "Mohammad Khan",
		"date": "2024-10-09T04:00:00.000Z",
		"excerpt": "Students from Concordia and McGill walkout of classes on Oct. 7 to protest the ongoing genocide in Palestine and call for both universities to divest from Israel.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/03.News.Oct_7th_Walkout.Mohammed_Khan.online.Andrae_Lerone_Lewis.1078116_900_675_90.jpg",
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/03.News.Oct_7th_Walkout.Mohammed_Khan.online.Andrae_Lerone_Lewis.1078187_900_675_90.jpg"
		],
		"slug": "breaking-the-colonial-wall-over-1000-students-walk-out-for-divestment-on-the-anniversary-of-oct-7"
	},
	{
		"link": "https://thelinknewspaper.ca/article/one-year-since-oct-7",
		"title": "One year since Oct. 7",
		"section": "NEWS",
		"author": "Hannah Scott-Talib",
		"date": "2024-10-01T04:00:00.000Z",
		"excerpt": "Montreal activists for Palestine speak on the movement\u2019s mobilization efforts this past year and plans for the future.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/_....shadowlerone.001_900_1349_90.jpg"
		],
		"slug": "one-year-since-oct-7"
	},
	{
		"link": "https://thelinknewspaper.ca/article/the-cedar-and-olive-tree-are-forever-interlinked",
		"title": "The cedar and olive tree are forever interlinked",
		"section": "NEWS",
		"author": "Yasmine Chouman",
		"date": "2024-10-01T04:00:00.000Z",
		"excerpt": "With Israel\u2019s ongoing aggression against Lebanon, the Lebanese community in Montreal reaffirms their solidarity with Palestine.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/03.News.lebanon.Mckintire.online.Andrae_Lewis.0079_900_600_90.jpg"
		],
		"slug": "the-cedar-and-olive-tree-are-forever-interlinked"
	},
	{
		"link": "https://thelinknewspaper.ca/article/pro-palestine-student-walkout-ends-in-three-arrests",
		"title": "Pro-Palestine student walkout ends in three arrests",
		"section": "NEWS",
		"author": "The Link",
		"date": "2024-09-26T04:00:00.000Z",
		"excerpt": "Concordia pro-Palestine walkout sees heavy police presence, an altercation between pro-Israel and pro-Palestine students, and three arrests.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/02.News.walkout.Lea.online.Andrae_Lewis.0277_900_599_90.jpeg"
		],
		"slug": "pro-palestine-student-walkout-ends-in-three-arrests"
	},
	{
		"link": "https://thelinknewspaper.ca/article/montreal-community-takes-to-the-street-to-defend-trans-rights",
		"title": "Montreal community takes to the street to defend trans rights",
		"section": "NEWS",
		"author": "Francis Turcotte",
		"date": "2024-09-22T04:00:00.000Z",
		"excerpt": "On Sept. 20, Montreal pro-trans activists counter-protested the nationwide anti-trans \u201c1 Million March 4 Children\u201d protest for a second year.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/02.News.transportest.francis.online.Andrae_Lewis.9315_900_600_90.jpg",
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/02.News.transportest.francis.online.Andrae_Lewis.9233_900_1350_90.jpg",
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/02.News.transportest.francis.online.Andrae_Lewis.9237_900_1350_90.jpg"
		],
		"slug": "montreal-community-takes-to-the-street-to-defend-trans-rights"
	},
	{
		"link": "https://thelinknewspaper.ca/article/concordia-needs-to-support-its-workers",
		"title": "Editorial: Hybrid work is here to stay",
		"section": "OPINIONS",
		"author": "The Link",
		"date": "2024-09-17T04:00:00.000Z",
		"excerpt": "The Link commends the university for listening to its workers and hopes the agreement contains guidelines that meet CUPEU\u2019s demands for a better work-from-home system.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/_MG_8766_900_600_90.JPG"
		],
		"slug": "concordia-needs-to-support-its-workers"
	},
	{
		"link": "https://thelinknewspaper.ca/article/fighting-back-against-transphobic-movements-in-montreal",
		"title": "Fighting back against transphobic movements in Montreal",
		"section": "NEWS",
		"author": "Hannah Scott-Talib",
		"date": "2024-09-17T04:00:00.000Z",
		"excerpt": "Breaking down the annual national anti-trans movement and what can be done to counter it.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/02.News.transrights.hannahscotttalib.print.Andrae_Lewis.001_900_600_90.jpg"
		],
		"slug": "fighting-back-against-transphobic-movements-in-montreal"
	},
	{
		"link": "https://thelinknewspaper.ca/article/stingers-53-martlets-5-stingers-capture-the-20th-annual-kelly-anne-drummond-cup",
		"title": "Stingers 53, Martlets 5: Stingers capture the 20th annual Kelly-Anne Drummond Cup",
		"section": "SPORTS",
		"author": "Conor Tomalty",
		"date": "2024-09-10T04:00:00.000Z",
		"excerpt": "The Stingers trounced the McGill Martlets to capture the Kelly-Anne Drummond Cup.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/20240908-_DSC0723_900_600_90.jpg"
		],
		"slug": "stingers-53-martlets-5-stingers-capture-the-20th-annual-kelly-anne-drummond-cup"
	},
	{
		"link": "https://thelinknewspaper.ca/article/cupeu-rejects-concordias-offer-officially-goes-on-strike",
		"title": "CUPEU rejects Concordia\u2019s offer, officially goes on strike",
		"section": "NEWS",
		"author": "Genevi\u00e8ve Sylvestre",
		"date": "2024-09-05T04:00:00.000Z",
		"excerpt": "The Concordia University Professional Employees Union (CUPEU) goes on strike on Sept. 4 for better access to a hybrid work schedule.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/_MG_8769_900_600_90.JPG"
		],
		"slug": "cupeu-rejects-concordias-offer-officially-goes-on-strike"
	},
	{
		"link": "https://thelinknewspaper.ca/article/sphr-concordia-is-going-independent",
		"title": "SPHR Concordia is going independent",
		"section": "NEWS",
		"author": "Maria Cholakova",
		"date": "2024-09-03T04:00:00.000Z",
		"excerpt": "While fighting for Palestine, SPHR is also facing internal changes.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/01.news.SPHR.Maria.print.andrae.01_900_600_90.jpg"
		],
		"slug": "sphr-concordia-is-going-independent"
	},
	{
		"link": "https://thelinknewspaper.ca/article/divestment-then-divestment-now-why-does-it-seem-tougher",
		"title": "Divestment then. Divestment now. Why does it seem tougher?",
		"section": "NEWS",
		"author": "Hannah Vogan",
		"date": "2024-09-03T04:00:00.000Z",
		"excerpt": "The student-led divestment movement against Israel follows a similar framework to the one that helped liberate South Africa from Apartheid. Although the tactics are the same, the political climate may be challenging for current pro-Palestinian activists.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/20240114-BZ9A2401-3_900_675.png"
		],
		"slug": "divestment-then-divestment-now-why-does-it-seem-tougher"
	},
	{
		"link": "https://thelinknewspaper.ca/article/montrealers-protest-300-days-of-genocide-in-palestine",
		"title": "Montrealers protest 300 days of genocide in Palestine",
		"section": "NEWS",
		"author": "Genevi\u00e8ve Sylvestre",
		"date": "2024-08-06T04:00:00.000Z",
		"excerpt": "Protesters walked through the streets of downtown Montreal to stand in solidarity with Palestine and demand an immediate ceasefire.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/20240803-_DSC0176-2_900_600_90.jpg"
		],
		"slug": "montrealers-protest-300-days-of-genocide-in-palestine"
	},
	{
		"link": "https://thelinknewspaper.ca/article/hundreds-gather-for-trans-day-of-vengeance",
		"title": "Hundreds gather for trans day of vengeance",
		"section": "NEWS",
		"author": "Andra\u00e9 Lerone Lewis",
		"date": "2024-04-02T04:00:00.000Z",
		"excerpt": "In light of trans visibility day, the CAQ\u2019s complicity in province-wide transphobia was protested.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/20240331-20240331-BZ9A0025_900_600_90.jpg",
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/20240331-20240331-BZ9A9944_900_1124_90.jpg",
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/20240331-20240331-BZ9A0228_900_600_90.jpg",
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/20240331-20240331-BZ9A9992_900_1125_90.jpg"
		],
		"slug": "hundreds-gather-for-trans-day-of-vengeance"
	},
	{
		"link": "https://thelinknewspaper.ca/article/montrealers-continue-fighting-against-police-brutality",
		"title": "Montrealers continue fighting against police brutality",
		"section": "NEWS",
		"author": "Julia Cieri",
		"date": "2024-03-17T04:00:00.000Z",
		"excerpt": "Demonstrators denounce police budget increases as well as the systemic targeting of marginalized communities by the police force.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/Screenshot_2024-03-17_at_4.32.16_PM_900_601.png"
		],
		"slug": "montrealers-continue-fighting-against-police-brutality"
	},
	{
		"link": "https://thelinknewspaper.ca/article/student-associations-strike-against-tuition-hikes",
		"title": "Student associations strike against tuition hikes",
		"section": "NEWS",
		"author": "Sol\u00e8ne de Bar",
		"date": "2024-03-16T04:00:00.000Z",
		"excerpt": "Several students associations across Concordia, cumulating in over 20,000 students, were striking and picketing their classes.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/Screenshot_2024-03-25_at_11.51.39_AM_900_602.png"
		],
		"slug": "student-associations-strike-against-tuition-hikes"
	},
	{
		"link": "https://thelinknewspaper.ca/article/striking-conu-students-and-staff-protest-tuition-hikes",
		"title": "Striking ConU students and staff protest tuition hikes",
		"section": "NEWS",
		"author": "Iness Rifay",
		"date": "2024-03-15T04:00:00.000Z",
		"excerpt": "On March 13, hundreds of students protested against the tuition hikes.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/IMG_5539_900_600_90.JPG",
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/IMG_5541_900_600_90.JPG"
		],
		"slug": "striking-conu-students-and-staff-protest-tuition-hikes"
	},
	{
		"link": "https://thelinknewspaper.ca/article/students-picket-legaults-office-against-tuition-hikes",
		"title": "Students picket Legault\u2019s office against tuition hikes",
		"section": "NEWS",
		"author": "Claudia Beaudoin",
		"date": "2024-02-25T05:00:00.000Z",
		"excerpt": "Frustration persists following CAQ\u2019s decision to increase tuition.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/Screenshot_2024-02-25_at_4.25.43_PM_900_601.png"
		],
		"slug": "students-picket-legaults-office-against-tuition-hikes"
	},
	{
		"link": "https://thelinknewspaper.ca/article/montrealers-urge-government-to-stop-bill-31",
		"title": "Montrealers urge government to stop Bill 31",
		"section": "NEWS",
		"author": "Sarah-Maria Khoueiry",
		"date": "2024-02-05T05:00:00.000Z",
		"excerpt": "Various tenant unions and demonstrators continue their fight against Bill 31 and its possible implementation.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/Screenshot_2024-02-05_at_6.27.49_PM_900_602.png"
		],
		"slug": "montrealers-urge-government-to-stop-bill-31"
	},
	{
		"link": "https://thelinknewspaper.ca/article/montreal-students-join-forces-in-protest-for-palestine",
		"title": "Montreal students join forces in protest for Palestine",
		"section": "NEWS",
		"author": "Hannah Scott-Talib",
		"date": "2024-02-04T05:00:00.000Z",
		"excerpt": "Students from universities all around the city walked out of their classes to march to denounce their universities\u2019 support of Israel.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/Screenshot_2024-02-04_at_9.49.39_PM_900_600.png"
		],
		"slug": "montreal-students-join-forces-in-protest-for-palestine"
	},
	{
		"link": "https://thelinknewspaper.ca/article/where-gender-and-class-intersect",
		"title": "Where gender and class intersect",
		"section": "NEWS",
		"author": "Leo Litke",
		"date": "2024-01-16T05:00:00.000Z",
		"excerpt": "The Link sat down with Celeste Trianon to discuss gender identity, expression and class",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/20231120-_Z9A9225-2_900_1350_90.jpg"
		],
		"slug": "where-gender-and-class-intersect"
	},
	{
		"link": "https://thelinknewspaper.ca/article/transgender-community-and-allies-gather-for-trans-remembrance-march",
		"title": "Transgender community and allies gather for trans remembrance march",
		"section": "NEWS",
		"author": "Leo Litke",
		"date": "2023-11-24T05:00:00.000Z",
		"excerpt": "On Nov. 20, several pro-trans activists, allies and members of the trans and LGBTQIA2S+ community marched in the name of the those lost to transphobic violence.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/IMG_1411_900_589_90.jpg"
		],
		"slug": "transgender-community-and-allies-gather-for-trans-remembrance-march"
	},
	{
		"link": "https://thelinknewspaper.ca/article/editorial-mainstream-media-failed-palestinian-students",
		"title": "Editorial: Mainstream media failed Palestinian students",
		"section": "OPINIONS",
		"author": "The Link",
		"date": "2023-11-14T05:00:00.000Z",
		"excerpt": "The Link is ashamed of papers like the Montreal Gazette for their questionable reporting on the events of Nov. 8 at Hall. Rather than send reporters to cover the altercation with on-the-ground reporting, the Gazette published statements by organizations that weren\u2019t eye-witnesses to the events on campus.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/Andrae_5_900_454.png"
		],
		"slug": "editorial-mainstream-media-failed-palestinian-students"
	},
	{
		"link": "https://thelinknewspaper.ca/article/pro-palestinian-student-groups-across-montreal-unite-on-mcgill-campus",
		"title": "Pro-Palestinian student groups across Montreal unite on McGill campus",
		"section": "NEWS",
		"author": "Julia Cieri",
		"date": "2023-11-13T05:00:00.000Z",
		"excerpt": "Student groups from UdeM, Concordia University and McGill University gathered in solidarity to denounce their respective schools\u2019 complicity with the state of Israel.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/Screenshot_2023-11-13_at_11.21.58_AM_900_602.png"
		],
		"slug": "pro-palestinian-student-groups-across-montreal-unite-on-mcgill-campus"
	},
	{
		"link": "https://thelinknewspaper.ca/article/thousands-rally-in-urgent-last-minute-demonstration-for-gaza",
		"title": "Thousands rally in urgent last-minute demonstration for Gaza",
		"section": "NEWS",
		"author": "Abby Cole",
		"date": "2023-10-18T04:00:00.000Z",
		"excerpt": "This protest is one of many this week occurring around the city to demand justice and freedom for Palestine",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/Screenshot_2023-10-18_at_10.48.56_PM_900_601.png"
		],
		"slug": "thousands-rally-in-urgent-last-minute-demonstration-for-gaza"
	},
	{
		"link": "https://thelinknewspaper.ca/article/palestinian-students-claim-concordia-dean-of-students-waved-middle-finger-at-them",
		"title": "Palestinian students claim Concordia dean of students waved middle finger at them",
		"section": "NEWS",
		"author": "Maria Cholakova",
		"date": "2023-10-17T04:00:00.000Z",
		"excerpt": "While driving past the university, the Dean of students allegedly gave the middle finger to a Palestinian student. Concordia denies the gesture.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/protest_photo_flag_copy_900_600_90.jpg"
		],
		"slug": "palestinian-students-claim-concordia-dean-of-students-waved-middle-finger-at-them"
	},
	{
		"link": "https://thelinknewspaper.ca/article/montreal-pro-palestinian-march-for-gaza",
		"title": "Montreal pro-Palestinian march for Gaza",
		"section": "NEWS",
		"author": "Sarah-Maria Khoueiry",
		"date": "2023-10-16T04:00:00.000Z",
		"excerpt": "On the evening of Oct. 13, over ten thousand supporters gathered in the Sir George Williams Campus for Gaza.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/Out_for_Gaza_protest-10_900_600_90.jpg",
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/Out_for_Gaza_protest-8_900_600_90.jpg"
		],
		"slug": "montreal-pro-palestinian-march-for-gaza"
	},
	{
		"link": "https://thelinknewspaper.ca/article/being-trans-in-an-all-girls-high-school-taught-me-to-hate-myself",
		"title": "Being trans in an all-girls high school taught me to hate myself",
		"section": "OPINIONS",
		"author": "Sophie Dufresne",
		"date": "2023-10-03T04:00:00.000Z",
		"excerpt": "In high school, I struggled with my gender identity, feeling trapped by societal norms and transphobia.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/Issue3-News-Transpiece_900_599_90.jpg"
		],
		"slug": "being-trans-in-an-all-girls-high-school-taught-me-to-hate-myself"
	},
	{
		"link": "https://thelinknewspaper.ca/article/montreal-trans-community-reflects-on-nationwide-bigotry",
		"title": "Montreal trans community reflects on nationwide bigotry",
		"section": "NEWS",
		"author": "Andra\u00e9 Lerone Lewis",
		"date": "2023-10-03T04:00:00.000Z",
		"excerpt": "Following the OMMC passing through Montreal, the city\u2019s transgender community rallies together to support one another in a time of unease.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/Issue3-News-Transpiece_900_599_90.jpg",
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/Issue3-News-Transpiece2_900_600_90.jpg"
		],
		"slug": "montreal-trans-community-reflects-on-nationwide-bigotry"
	},
	{
		"link": "https://thelinknewspaper.ca/article/down-with-hatred-hundreds-of-pro-trans-protestors-counter-the-ommc",
		"title": "\u201cDown with hatred\u201d: Hundreds of pro-trans protestors counter the OMMC",
		"section": "NEWS",
		"author": "Leo Litke",
		"date": "2023-09-25T04:00:00.000Z",
		"excerpt": "In the light of the One Million March for Children being organized throughout the country, trans activists in the cities responded with counter-protests of their own.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/20230920-_YUL6985_900_600_90.jpg",
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/20230920-_YUL6971_900_600_90.jpg",
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/20230920-_YUL7007_900_600_90.jpg"
		],
		"slug": "down-with-hatred-hundreds-of-pro-trans-protestors-counter-the-ommc"
	},
	{
		"link": "https://thelinknewspaper.ca/article/invest-in-community-not-police",
		"title": "\u201cInvest in community, not police\u201d",
		"section": "NEWS",
		"author": "Julia Israel",
		"date": "2023-09-20T04:00:00.000Z",
		"excerpt": "The Defund la Police festival is back for its second yearly edition, aiming to educate, discuss and raise awareness on various topics such as decriminalization and community justice.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/Screenshot_2023-09-20_at_2.33.46_PM_900_591.png",
			"https://thelinknewspaper.ca/images/made/images/articles/_resized/Screenshot_2023-09-20_at_2.42.13_PM_900_598.png"
		],
		"slug": "invest-in-community-not-police"
	},
	{
		"link": "https://thelinknewspaper.ca/article/freedom-and-liberation-political-prisoners-at-forefront-of-palestinian-liberation",
		"title": "Freedom and Liberation: Political Prisoners at Forefront of Palestinian Liberation",
		"section": "NEWS",
		"author": "Sarah-Maria Khoueiry",
		"date": "2022-10-23T04:00:00.000Z",
		"excerpt": "On Oct. 22, protesters gathered in front of the French consulate of Montreal in solidarity with Lebanese political prisoner Georges Abdallah.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/Volume_43/News/_resized/Palestine_(1_sur_3)_900_563_90.jpg",
			"https://thelinknewspaper.ca/images/made/images/articles/Volume_43/News/_resized/Palestine_(3_sur_3)_900_563_90.jpg"
		],
		"slug": "freedom-and-liberation-political-prisoners-at-forefront-of-palestinian-liberation"
	},
	{
		"link": "https://thelinknewspaper.ca/article/truth-and-reconciliation-march-turns-the-streets-orange",
		"title": "Truth and Reconciliation March Turns the Streets Orange",
		"section": "NEWS",
		"author": "Dallas Calvert",
		"date": "2022-10-07T04:00:00.000Z",
		"excerpt": "Indigenous People and allies march for the second National Day for Truth and Reconciliation.",
		"images": [
			"https://thelinknewspaper.ca/images/made/images/articles/Volume_43/News/_resized/Andrae\u03012_900_600_90.jpg"
		],
		"slug": "truth-and-reconciliation-march-turns-the-streets-orange"
	}
]